import axios from 'axios';

import { responseInterceptor, errorInterceptor } from './interceptors';
import { Environment } from '../../../environment';


const Api = axios.create({
  baseURL: Environment.URL_BASE,
  withCredentials:true,
});

Api.interceptors.response.use(
  (response) => responseInterceptor(response),
  (error) => errorInterceptor(error),
);
/*
const getCookie = (name: string) => {
  const value = `; ${document.cookie}`;
  const parts = value.split(`; ${name}=`);
  if (parts.length === 2 ) {
    return parts.pop()?.split(';').shift();
  }
};

Api.interceptors.request.use((config) => {
  console.log("Cookies");
  const token = getCookie('jwt'); // Busca o token do cookie
  if (token) {
    config.headers.Authorization = `Bearer ${token}`; // Adiciona o cabeçalho, se necessário
  }
  return config;
}, (error) => {
  return Promise.reject(error);
});  */

export { Api };
